module.exports = __webpack_public_path__ + "img/bg2.47f8d792.png";